module.exports = __webpack_public_path__ + "media/categories/2047-2637dd3a.svg";